export * from './lib/module-card/module-card.component';
